module.exports = __webpack_public_path__ + "static/img/image_to_video.340f965.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/image_to_video.gif
// module id = Xvn2
// module chunks = 1